import React from 'react';
import { ModalController } from '../../../components/Modal/ControlledModal';
import { useChanges, Form } from '../../../components/Form/Form';
import { Checkbox } from '../../../components/Form/Checkbox/Checkbox';
import { handleError } from '../../../model/notification';
import { flatten } from 'lodash';
import { Order } from '../../../model/order';
import { PicklistPatch, createPicklist } from '../../../model/picklist';
import { t } from '../../../locales/translate';
import { Stack } from '../../../components/Stack/Stack';

interface Props {
  orders: Order[];
  controller: ModalController<PicklistPatch>;
}

export function PrintOrders({ orders, controller }: Props): JSX.Element {
  const [, , model, trackChanges] = useChanges<PicklistPatch>({
    containsPicklist: true,
    containsTicketlist: false,
    containsDeliveries: true,
  });

  async function handleOnSubmit(): Promise<void> {
    const deliveries = orders.map((order) => order.deliveries);
    const deliveryIds = flatten(deliveries).map((item) => item.id);
    try {
      await createPicklist({
        deliveryIds,
        ...model,
      });
    } catch (error) {
      handleError(error);
    }
  }

  function checkIfCanSubmit(): boolean {
    if (model.containsPicklist || model.containsTicketlist || model.containsDeliveries) {
      return true;
    }
    return false;
  }

  return (
    <Form className="orders__export-fulfillment" model={model} onInput={trackChanges}>
      {() => {
        controller.configure({
          onSubmit: handleOnSubmit,
          canSubmit: checkIfCanSubmit(),
        });
        return (
          <Stack>
            <Checkbox name="containsPicklist" label={t.model.picklist._name} />
            <Checkbox name="containsTicketlist" label={t.model.order.ticketList} />
            <Checkbox name="containsDeliveries" label={t.model.delivery._plural} />
          </Stack>
        );
      }}
    </Form>
  );
}
